import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: { label: string; to: string };
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col gap-4 ${
        align === "center" ? "items-center text-center" : "sm:flex-row sm:items-end sm:justify-between"
      }`}
    >
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" aria-hidden="true"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          {action.label}
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}